/**
 * „NICHT ZUSTAENDIG" STATT SCHWEIGEN (Kanzler Dev, 14.10.2026; server/lib/guide-fenster-abfrage.ts).
 *
 * Jede Seite mit Hauptverbindung bekommt `control:guide-fenster`. Beantwortet sie die Abfrage
 * nicht selbst (keine App-Oberflaeche wie bei Einzelpanels, keine Guide-Steuerung wie bei einem
 * Partner, Schattenfenster ohne Erlaubnis), meldet sie nur „nicht zustaendig" — mit Abfrage- und
 * Verbindungskennung, sonst NICHTS. Kein Titel, keine Bühne: ein Partner-Fenster verraet damit
 * nichts ueber Rafaels Buehnen, und der Server weiss trotzdem, dass „stumm" nicht „tot" heisst.
 */
const beantwortet = new Set<string>();

/** Die App-Oberflaeche hat diese Abfrage selbst beantwortet (mit ihren Fensterangaben). */
export function fensterAbfrageBeantwortet(abfrageId: string): void { beantwortet.add(abfrageId); }

/**
 * Nach allen Handlern derselben Nachricht aufrufen (SessionStore): hat keiner beantwortet,
 * geht „nicht zustaendig" an den Server. `false` = nichts gesendet (schon beantwortet / keine Kennung).
 */
export function nichtZustaendigFallsUnbeantwortet(abfrageId: unknown, clientId: string | undefined, senden: typeof fetch = fetch): boolean {
  if (typeof abfrageId !== 'string') return false;
  if (beantwortet.delete(abfrageId)) return false;
  if (!clientId) return false;
  void senden('/api/control/fensterabfrage/nicht-zustaendig', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ abfrageId, clientId }), signal: AbortSignal.timeout(5000),
  }).then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); })
    .catch(e => console.error('[fensterabfrage] „nicht zuständig“ nicht angekommen:', e));
  return true;
}
